import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

export default function FileUploadProgress({loaded, fileName}) {

    return (
        <Box
            width={"90%"}
            maxWidth={"400px"}
            background={"black"}
            borderRadius={"5px"}
            padding={"20px"}
            border={"1px solid grey"}
        >
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
            >{fileName}</Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{height: "30px"}}
                position={"relative"}
                overflow={'hidden'}
            >

                <Box
                    position="absolute"
                    left={0}
                    right={0}
                    top={0}
                    bottom={0}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    color={"white"}
                >
                    {loaded}%
                </Box>
                <Box
                    position="absolute"
                    left={0}
                    width={`${loaded}%`}
                    top={0}
                    height={'100%'}
                    backgroundColor={`grey`}
                    overflow={'hidden'}
                >

                    <Box
                        position="absolute"
                        left={0}
                        width={'360px'}
                        top={0}
                        bottom={0}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        color={'black'}
                    >
                        {loaded}%
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}